import React, { useState, Suspense, lazy } from 'react';
import { AppBar, Tabs, Tab, Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

const Calendar = lazy(() => import('../Dashboard/Calendar'));
const FAQ = lazy(() => import('../Dashboard/FAQ'));
const ContactPage = lazy(() => import('../AITalker/ContactPage'));
const CustomerManagement = lazy(() => import('./CustomerManagement'));
const Products = lazy(() => import('./Products'));

const Resources = () => {
  const location = useLocation();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabs = [
    { id: 'contact', label: 'Contact', component: ContactPage, path: '/resources/contact' },
    { id: 'products', label: 'Products', component: Products, path: '/resources/products' },
    { id: 'calendar', label: 'Calendar', component: Calendar, path: '/resources/calendar' },
    { id: 'customers', label: 'Customers', component: CustomerManagement, path: '/resources/customers' },
    { id: 'faq', label: 'Feedback IQ', component: FAQ, path: '/resources/faq' },
  ];


  React.useEffect(() => {
    const activeTab = tabs.findIndex(tab => location.pathname.startsWith(tab.path));
    if (activeTab !== -1) {
      setValue(activeTab);
    }
  }, [location.pathname]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons="auto"
        >
          {tabs.map((tab) => (
            <Tab key={tab.id} label={tab.label} component={Link} to={tab.path} />
          ))}
        </Tabs>
      </AppBar>
      <Box sx={{ p: 3 }}>
        <Suspense fallback={<div>Loading...</div>}>
          {React.createElement(tabs[value].component)}
        </Suspense>
      </Box>
    </Box>
  );
};

export default Resources;
